// extracted by mini-css-extract-plugin
module.exports = {"container":"TermsAndConditions_container__lrPHI","terms":"TermsAndConditions_terms__n42vu","link":"TermsAndConditions_link__Bqqhp"};